import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["innerRef"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Button from '@atlaskit/button';
var buttonStyles = css({
  display: 'flex',
  background: "var(--ds-background-neutral, #091E420F)",
  color: "var(--ds-icon, #44546F)",
  '&:hover': {
    background: "var(--ds-background-neutral-hovered, #091E4224)"
  },
  '&:active': {
    background: "var(--ds-background-neutral-pressed, #091E424F)"
  },
  width: '1.375rem',
  height: '1.25rem'
});
export var StyledButton = function StyledButton(_ref) {
  var innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(Button, _extends({}, props, {
    ref: innerRef
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
    ,
    css: buttonStyles
  }));
};